const buttonPushLocale = {
  buttonPush: {
    buttonPush: "Appui boutton",
    lastPushButton: "Dernier appui",
    pushButtonCount: "Nombre d'appuis {n} heures",
  },
};

export type ButtonPushLocale = typeof buttonPushLocale;
export default buttonPushLocale;
